/**
 * @generated SignedSource<<970a67445b68a455c0e08e70a8139525>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingsPanelHeader_viewer$data = {
  readonly uxSimplificationEnabled: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"DatePickerAgenda_viewer" | "MeetingsPanelMenu_viewer">;
  readonly " $fragmentType": "MeetingsPanelHeader_viewer";
};
export type MeetingsPanelHeader_viewer$key = {
  readonly " $data"?: MeetingsPanelHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingsPanelHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingsPanelHeader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxSimplificationEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingsPanelMenu_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatePickerAgenda_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "eabd3c797030808d95070dd1da18f395";

export default node;
